import styled from "styled-components";
import { theme, Colors, Styleguide } from "../../theme";
import Stack from "../Stack/Stack";
import { User } from "../../types/user";

import React from "react";
import Config from "../../config";
import { Logout } from "../../actions/OIDC";

export interface UserCardProps {
  user: User;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  gap: 8px;
  background: ${theme(Colors.white, Colors.gray[500])};
  border: 1px solid ${theme(Colors.gray[300], Colors.gray[200])};
  border-radius: 8px;
  overflow: hidden;
  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    padding: 24px;
  }
`;

const Avatar = styled.img`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;

  @media screen and (min-width: ${Styleguide.breakpoints.tablet}) {
    width: 72px;
    height: 72px;
  }
`;

const Content = styled.div`
  min-width: 0;
`;

const UserEmail = styled.p`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0;
  color: ${theme(Colors.gray[300], Colors.gray[100])};
  font-family: ${Styleguide.fonts.body.name};
  font-weight: ${Styleguide.fontWeights.regular};
  font-size: ${Styleguide.fontSizes[14]};

  @media screen and (min-width: ${Styleguide.breakpoints.tablet}) {
    font-size: ${Styleguide.fontSizes[16]};
  }
`;

const UserName = styled.p`
  color: ${theme(Colors.gray[400], Colors.white)};
  font-size: ${Styleguide.fontSizes[18]};
  font-weight: ${Styleguide.fontWeights.semibold};
  font-family: ${Styleguide.fonts.heading.name};
  margin: 0;

  @media screen and (min-width: ${Styleguide.breakpoints.tablet}) {
    font-size: ${Styleguide.fontSizes[24]};
  }
`;

const ButtonCallback = styled.button`
  border: none;
  background: none;
  padding: 2px;
  width: fit-content;
  cursor: pointer;
  color: ${theme(Colors.blue[100], Colors.lightBlue[100])};

  text-align: left;
  text-decoration: underline;
  font-family: ${Styleguide.fonts.body.opensans_regular};
  font-weight: ${Styleguide.fontWeights.bold};
  font-size: ${Styleguide.fontSizes[14]};

  :focus {
    outline-width: 3px;
    outline-style: solid;
    border-radius: 8px;
    outline-offset: 2px;
    outline-color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
  }

  @media screen and (min-width: ${Styleguide.breakpoints.tablet}) {
    font-size: ${Styleguide.fontSizes[16]};
  }
`;

export function UserCard({ user }: UserCardProps) {
  const logout = () => {
    Logout();
  };

  return (
    <Container id="card-user" aria-label="Informações da conta">
      <Stack direction="row" spacing={{ mobile: 16, desktop: 24 }}>
        <Avatar src={user.photo}></Avatar>
        <Content>
          <Stack spacing={4}>
            <UserName>{user.name}</UserName>
            <UserEmail>{user.email}</UserEmail>
            <ButtonCallback onClick={logout} type="button">
              Alterar conta
            </ButtonCallback>
          </Stack>
        </Content>
      </Stack>
    </Container>
  );
}

export default UserCard;
